export function buildCanonicalUrlFromPath(
  path: string,
  locale: string,
): string {
  const canonicalUrlHost = "https://www.sonder.com";
  const canonicalUrlLocale = locale === "en-US" ? "" : locale;
  const canonicalUrl = new URL(
    `${canonicalUrlLocale}${path}`,
    canonicalUrlHost,
  );

  canonicalUrl.search = "";

  return canonicalUrl.href.toLowerCase().replace(/\/+$/, "");
}
